const ArrowSvg = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path
        d="M11.3459 9.84704C11.2472 9.94498 11.1134 10 10.9739 10C10.8343 10 10.7005 9.94498 10.6018 9.84704L7.99682 7.26103L5.39185 9.84704C5.2926 9.9422 5.15967 9.99486 5.02168 9.99367C4.8837 9.99248 4.75171 9.93754 4.65414 9.84068C4.55656 9.74381 4.50122 9.61278 4.50002 9.4758C4.49882 9.33883 4.55186 9.20686 4.64773 9.10833L7.62476 6.15296C7.72345 6.05502 7.85728 6 7.99682 6C8.13637 6 8.2702 6.05502 8.36889 6.15296L11.3459 9.10833C11.4446 9.2063 11.5 9.33916 11.5 9.47768C11.5 9.61621 11.4446 9.74907 11.3459 9.84704Z"
        fill="#D5D5D5"
      />
    </svg>
  );
};

export default ArrowSvg;
